(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hsh-golden-bloom"] && !Shopify.designMode) return;
  try {
    

class HshGoldenBloom extends HTMLElement {
connectedCallback(){
if(this.dataset.ready)return;this.dataset.ready='true';
const menu=this.querySelector('.menu-toggle'),nav=this.querySelector('nav');
menu?.addEventListener('click',()=>{const open=menu.getAttribute('aria-expanded')!=='true';menu.setAttribute('aria-expanded',String(open));nav.classList.toggle('open',open)});
nav?.querySelectorAll('a').forEach(a=>a.addEventListener('click',()=>{nav.classList.remove('open');menu.setAttribute('aria-expanded','false')}));
this.querySelectorAll('[data-filter]').forEach(b=>b.addEventListener('click',()=>this.filter(b.dataset.filter)));
this.querySelectorAll('input[name="gel-size"]').forEach(r=>r.addEventListener('change',()=>{this.querySelector('.gel-price').textContent='$'+r.value}));
const dialog=this.querySelector('dialog');let opener;
this.querySelectorAll('[data-open-ritual]').forEach(b=>b.addEventListener('click',()=>{opener=b;dialog.showModal()}));
this.querySelector('.close-dialog').addEventListener('click',()=>dialog.close());
dialog.addEventListener('click',e=>{if(e.target===dialog){const r=dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)dialog.close()}});
dialog.addEventListener('close',()=>opener?.focus());
const suggestions={sea:[this.getAttribute("data-ritual-sea-title"),this.getAttribute("data-ritual-sea-description")],herbs:[this.getAttribute("data-ritual-herbs-title"),this.getAttribute("data-ritual-herbs-description")],care:[this.getAttribute("data-ritual-care-title"),this.getAttribute("data-ritual-care-description")],kits:[this.getAttribute("data-ritual-kits-title"),this.getAttribute("data-ritual-kits-description")]};
this.querySelectorAll('[data-ritual]').forEach(b=>b.addEventListener('click',()=>{this.querySelectorAll('[data-ritual]').forEach(x=>x.classList.toggle('selected',x===b));const result=this.querySelector('.ritual-result'),data=suggestions[b.dataset.ritual];result.hidden=false;result.querySelector('h3').textContent=data[0];result.querySelector('p').textContent=data[1];result.querySelector('a').onclick=()=>{this.filter(b.dataset.ritual);dialog.close();setTimeout(()=>this.querySelector('#collections').scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'}),0)}}));
}
filter(category){let count=0;this.querySelectorAll('.collection-card').forEach(c=>{c.hidden=category!=='all'&&c.dataset.category!==category;if(!c.hidden)count++});this.querySelectorAll('[data-filter]').forEach(b=>{const active=b.dataset.filter===category;b.classList.toggle('active',active);b.setAttribute('aria-pressed',String(active))});this.querySelector('.filter-status').textContent=count===1?this.getAttribute('data-status-one'):this.getAttribute('data-status-many').replace('__COUNT__',String(count))}
}
if(!customElements.get('hsh-golden-bloom'))customElements.define('hsh-golden-bloom',HshGoldenBloom);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hsh-site-header"]) return;
  try {
    
if(!customElements.get('gb-header-controller')){customElements.define('gb-header-controller',class extends HTMLElement{connectedCallback(){const header=this.closest('.shopify-section');const button=header.querySelector('.gb-menu-button');const nav=header.querySelector('.gb-navigation');if(!button||!nav)return;button.addEventListener('click',()=>{const open=button.getAttribute('aria-expanded')!=='true';button.setAttribute('aria-expanded',String(open));nav.classList.toggle('is-open',open)});nav.addEventListener('keydown',e=>{if(e.key==='Escape'){button.setAttribute('aria-expanded','false');nav.classList.remove('is-open');button.focus()}})}})}

  } catch(e) { console.error(e); }
})();
})();
